import { useCallback, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDmPersona } from '../context/DmPersonaContext';
import { t } from './i18n';
import { isPersonaAuthError, personaLoginPath } from './personaAuth';

/**
 * On 401 / token -401: alert once, clear persona, go to /dm/users to log in again.
 */
export function usePersonaAuthRedirect(...errors) {
  const { logout } = useDmPersona();
  const navigate = useNavigate();
  const location = useLocation();
  const handled = useRef(false);

  const redirectToLogin = useCallback(
    (err) => {
      if (!isPersonaAuthError(err) || handled.current) return false;
      handled.current = true;
      window.alert(t('gameRps.play.errors.authExpired'));
      logout();
      navigate(personaLoginPath(location.pathname + location.search), { replace: true });
      return true;
    },
    [logout, navigate, location.pathname, location.search]
  );

  useEffect(() => {
    for (const err of errors) {
      if (redirectToLogin(err)) return;
    }
    // errors are query/mutation error objects — listed explicitly by callers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectToLogin, ...errors]);

  return redirectToLogin;
}
